"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalMonthlyPaymentPlanOutput = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var PaymentSchedule_1 = require("./PaymentSchedule");
var moment = require("moment/moment");
var RenewalMonthlyPaymentPlanOutput = /** @class */ (function (_super) {
    __extends(RenewalMonthlyPaymentPlanOutput, _super);
    function RenewalMonthlyPaymentPlanOutput(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleInstallmentPlan = function () {
            _this.setState(function (prevState) { return ({ isInstalmentPlanOpened: !prevState.isInstalmentPlanOpened }); });
        };
        _this.state = {
            isInstalmentPlanOpened: false
        };
        return _this;
    }
    RenewalMonthlyPaymentPlanOutput.prototype.render = function () {
        var interaction = this.props.interaction;
        var instalmentPlan = interaction.paymentDetails.instalmentPlan;
        var initialPaymentDate = moment.utc(instalmentPlan.instalments[0].dueDate, moment.ISO_8601).format("D MMMM YYYY");
        var firstInstallmentPayAmount = instalmentPlan.instalments[0].principal + instalmentPlan.instalments[0].interest;
        return React.createElement(React.Fragment, null,
            React.createElement("p", { className: "mb-4 h3 font-weight-bold" },
                "\u00A3",
                instalmentPlan.totalAmount),
            React.createElement("p", { className: "font-weight-bold" },
                "You have to pay ",
                React.createElement("span", null,
                    "\u00A3",
                    instalmentPlan.totalAmount),
                " to renew your next year's policy."),
            React.createElement("p", null,
                "Your new monthly pay will be ",
                React.createElement("span", { className: "font-weight-bold" },
                    "\u00A3",
                    instalmentPlan.monthlyPayment),
                "."),
            React.createElement("p", { className: "mb-4" }, "All figures include Insurance Premium Tax."),
            React.createElement("p", null,
                "The first instalment of ",
                React.createElement("span", { className: "font-weight-bold" },
                    "\u00A3",
                    firstInstallmentPayAmount.toFixed(2)),
                " will be taken on ",
                initialPaymentDate,
                "."),
            React.createElement("p", { className: "mb-4" }, "Please check your payment schedule below."),
            React.createElement("label", { htmlFor: "paymentScheduleTable", className: "text-center" },
                React.createElement("div", { className: "font-weight-700 mt-1" }, "Payment schedule")),
            React.createElement("p", { className: "mb-2 mt-1" },
                "You have to pay a total of ",
                React.createElement("span", { className: "font-weight-bold" },
                    "\u00A3",
                    instalmentPlan.totalAmount,
                    " "),
                "(",
                instalmentPlan.instalments.length,
                " instalments X ",
                instalmentPlan.monthlyPayment,
                ")"),
            React.createElement("div", { id: "paymentScheduleTable", className: "mb-3 mt-3" },
                React.createElement(PaymentSchedule_1.default, { isOpen: this.state.isInstalmentPlanOpened, instalments: instalmentPlan.instalments || [] })),
            React.createElement("div", { className: "text-left mt-4" }, !this.state.isInstalmentPlanOpened ?
                React.createElement("button", { className: "btn-inner-link btn-text text-center cursor-pointer text-decoration-none mb-4", onClick: this.toggleInstallmentPlan },
                    "+ ",
                    React.createElement("span", { className: "text-decoration-underline" }, "View instalments plan"))
                :
                    React.createElement("button", { className: "btn-inner-link btn-text text-center cursor-pointer text-decoration-none mb-4", onClick: this.toggleInstallmentPlan },
                        "- ",
                        React.createElement("span", { className: "text-decoration-underline" }, "Hide instalments plan"))));
    };
    return RenewalMonthlyPaymentPlanOutput;
}(plugin_journey_1.WidgetBase));
exports.RenewalMonthlyPaymentPlanOutput = RenewalMonthlyPaymentPlanOutput;
//# sourceMappingURL=RenewalMonthlyPaymentPlanOutput.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/common/RenewalMonthlyPaymentPlanOutput.js
// module id = 3233
// module chunks = 0